import React, { useState } from 'react';

import SPASelect from '@/components/admin/SysadminSPA/shared/SPASelect';

import useLessons from './useLessons';
import usePrograms, { PickerOption } from './usePrograms';

interface Props {
  onLessonChange: (lessonId: number | null) => void;
  onProgramChange?: (programId: number | null) => void;
}

const LABEL = 'tw-mb-1 tw-block tw-text-xs tw-text-spa-secondary';

// Cascading Program -> Lesson picker. Resolves the chosen program/lesson to their ids and hands them
// to the parent; selecting a new program clears the lesson.
const LessonPicker = ({ onLessonChange, onProgramChange }: Props) => {
  const [program, setProgram] = useState<PickerOption | null>(null);
  const [lesson, setLesson] = useState<PickerOption | null>(null);
  const { isLoading: programsLoading, programs } = usePrograms();
  const { isLoading: lessonsLoading, lessons } = useLessons(program?.value ?? null);

  const selectProgram = (option: PickerOption | null) => {
    setProgram(option);
    setLesson(null);
    onLessonChange(null);
    onProgramChange?.(option?.value ?? null);
  };

  const selectLesson = (option: PickerOption | null) => {
    setLesson(option);
    onLessonChange(option?.value ?? null);
  };

  return (
    <>
      <div className="tw-flex tw-w-72 tw-flex-col">
        <label className={LABEL} htmlFor="ptc-program">Program</label>
        <SPASelect<PickerOption>
          inputId="ptc-program"
          isLoading={programsLoading}
          options={programs}
          placeholder="Select a program"
          value={program}
          onChange={selectProgram}
        />
      </div>

      <div className="tw-flex tw-w-72 tw-flex-col">
        <label className={LABEL} htmlFor="ptc-lesson">Lesson</label>
        <SPASelect<PickerOption>
          inputId="ptc-lesson"
          isDisabled={!program}
          isLoading={lessonsLoading}
          options={lessons}
          placeholder={program ? 'Select a lesson' : 'Pick a program first'}
          value={lesson}
          onChange={selectLesson}
        />
      </div>
    </>
  );
};

export default LessonPicker;
